/* PZ Sep26 #7: PDP gallery native video — autoplay on view (IntersectionObserver, >=60% visible),
   pause on exit, pause/play + mute/unmute buttons. Markup: snippets/product-thumbnail.liquid (.pz-gv).
   Re-attaches after variant change / gallery re-render via a MutationObserver on each <media-gallery>.
   Videos start muted; nothing downloads until play() (preload="none", no autoplay attribute), except the
   prewarm below: when the slide immediately BEFORE the video becomes the active slide, preload switches to
   "metadata" (no play) so the first frame is ready on arrival. On initial load that only happens if the
   video is slide 2. The poster <img> layer stays on top until the 'playing' event (first frame rendered). */
(function () {
  if (window.__pzGalleryVideo) return;
  window.__pzGalleryVideo = true;

  var SEL = 'media-gallery video[data-pz-gv]';
  var seen = typeof WeakSet === 'function' ? new WeakSet() : { has: function () { return false; }, add: function () {} };

  function safePlay(v) {
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function sync(v) {
    var w = v.closest('.pz-gv');
    if (!w) return;
    w.classList.toggle('is-paused', v.paused);
    w.classList.toggle('is-unmuted', !v.muted);
    var pb = w.querySelector('.pz-gv__btn--play');
    var mb = w.querySelector('.pz-gv__btn--mute');
    if (pb) pb.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
    if (mb) mb.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && en.intersectionRatio >= 0.6) {
        if (!v.dataset.pzUserPaused) safePlay(v);
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: [0, 0.6] }) : null;

  function isShown(el) {
    return el && el.classList.contains('swiper-slide') && getComputedStyle(el).display !== 'none';
  }

  /* The slide shown immediately before this video's slide (skipping slides hidden by the shade filter). */
  function prevShownSlide(slide) {
    var s = slide.previousElementSibling;
    while (s && !isShown(s)) s = s.previousElementSibling;
    return s;
  }

  function prewarm(v) {
    if (v.dataset.pzPrewarmed) return;
    var slide = v.closest('.swiper-slide');
    if (!slide) return;
    var prev = prevShownSlide(slide);
    if (prev && prev.classList.contains('swiper-slide-active')) {
      v.dataset.pzPrewarmed = '1';
      v.preload = 'metadata';
    }
  }

  function prewarmAll() {
    document.querySelectorAll(SEL).forEach(prewarm);
  }

  function attach(v) {
    if (seen.has(v)) return;
    seen.add(v);
    v.muted = true;
    v.defaultMuted = true;
    ['play', 'pause', 'volumechange'].forEach(function (ev) {
      v.addEventListener(ev, function () { sync(v); });
    });
    /* first frame is on screen: only now drop the poster layer */
    v.addEventListener('playing', function () {
      var w = v.closest('.pz-gv');
      if (w) w.classList.add('is-playing');
    });
    sync(v);
    if (io) io.observe(v);
  }

  function scan() {
    document.querySelectorAll(SEL).forEach(attach);
    prewarmAll();
  }

  /* Buttons: delegated so clones (e.g. the lightbox copy of a slide) work too. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.pz-gv__btn');
    if (!btn) return;
    var w = btn.closest('.pz-gv');
    var v = w && w.querySelector('video');
    if (!v) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('pz-gv__btn--play')) {
      if (v.paused) { delete v.dataset.pzUserPaused; safePlay(v); }
      else { v.dataset.pzUserPaused = '1'; v.pause(); }
    } else {
      v.muted = !v.muted;
      if (!v.muted && v.paused && !v.dataset.pzUserPaused) safePlay(v);
    }
    sync(v);
  }, true);

  /* childList: gallery re-render / variant rebuild. class + style: swiper active-slide changes and the shade
     filter's show/hide — both drive the prewarm check. Debounced; every write above is guarded/idempotent. */
  var moTimer = null;
  var mo = 'MutationObserver' in window ? new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(scan, 60);
  }) : null;

  function start() {
    scan();
    if (mo) {
      document.querySelectorAll('media-gallery').forEach(function (g) {
        mo.observe(g, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
